import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./DisplayBox.styled";
const DEFAULT_BACKGROUND_OPACITY = 1;
export const DisplayBox = forwardRef((props, ref) => {
    const { backgroundOpacity = DEFAULT_BACKGROUND_OPACITY, border, borderRadius = "extraLarge", caretLocation, caretOffset = 16, caretSize = 18, children, depth = 0, hoverDepth = 0, ...otherProps } = props;
    return (_jsxs(Styled.Box, { ref: ref, depth: depth, hoverDepth: hoverDepth, backgroundOpacity: backgroundOpacity, border: border, borderRadius: borderRadius, "data-testid": "DisplayBox", ...otherProps, children: [_jsxs(Styled.BoxWrapper, { depth: depth, hoverDepth: hoverDepth, backgroundOpacity: backgroundOpacity, border: border, borderRadius: borderRadius, "data-testid": "DisplayBoxWrapper", children: [caretLocation && (_jsx(Styled.Caret, { border: border, size: caretSize, location: caretLocation, offset: caretOffset, "aria-hidden": "true", "data-testid": "DisplayBoxCaret" })), _jsx(Styled.Background, { borderRadius: borderRadius })] }), _jsx(Styled.Content, { borderRadius: borderRadius, children: children })] }));
});
DisplayBox.displayName = "DisplayBox";
// This is temporary and can be removed/replaced by initializers once this issue is resolved:
// https://github.com/styleguidist/react-docgen-typescript/issues/254
DisplayBox.defaultProps = {
    backgroundOpacity: 1,
    borderRadius: "extraLarge",
    caretOffset: 16,
    caretSize: 18,
    depth: 0,
    hoverDepth: 0
};
